import * as React from "react";
import { useState } from 'react';
import { TileLayout } from "@progress/kendo-react-layout";

import { PortfolioSummaryWidget } from "./portfolioSummaryWidget";
import { useEffect } from "react";
import { FamilySummaryWidget } from "./familyWidget";
import { CurrencyFormat } from "../utils/currencyFormattter";
import moment from "moment";
import { sbaAxios } from "../utils/sbaAxios";
import { getFamilyNetWorth } from "../../config/apiConfig";


const Composite = ({selectedFamily}) => {
  const [data, setData] = useState([{
    col: 1,
    colSpan: 1,
    rowSpan: 1
  }, {
    col: 1,
    colSpan: 1,
    rowSpan: 2
  }
  ]);
  const [gridData, setGridData] = useState([]);

  useEffect(() => {
      if (selectedFamily?.FamilyId) {
          getSummaryData(selectedFamily.FamilyId);
      }
  }, [selectedFamily]);
  const getSummaryData = (id) => {
      sbaAxios({ url: `${getFamilyNetWorth}?familyId=${id}` }).then(res => {
          setGridData(res)
      }
      ).catch(er => {
          setGridData([])
      })

  };
  useEffect(()=>{
    setNetWorthTitles([
      {
        id: 1,
      header:<div className="customHeaderSection"></div>,
        body: <PortfolioSummaryWidget selectedFamily={selectedFamily} />,
        sortOrder:1,
        isRemoved:false,
        resizable: false
      }
    ]);
  },[selectedFamily])
  const [netWorthTitles,setNetWorthTitles]=useState([
    {
      id: 1,
      header:<div className="customHeaderSection"></div>,
      body: <PortfolioSummaryWidget selectedFamily={selectedFamily} />,
      sortOrder:1,
      isRemoved:false,
      resizable: false
    },
  ]);
  
  const handleReposition = e => {
    setData(e.value);
    console.log(e.value);
  };


  return( <>

   
      <div className="row">
        
        {/* <div className="col-md-6" style={{backgroundColor:"rgba(76, 122, 159, 0.8)"}}>
        <div class="header-container p-2" style={{color:"white"}}>Investment</div>
        </div> */}
      </div>
      <div className="row">
      <div className="col-md-6 pb-2" style={{backgroundColor:"rgba(76, 122, 159, 0.8)"}}>
        <div class="header-container p-2" style={{color:"white"}}>Net Worth </div>
      <div className="d-flex flex-md-wrap mt-3 gap-3" >
        <div className="bg-white flex-grow-1 p-3 rounded board-border board">
          <p className="mb-8">Net Worth - 11/30/2024</p>
          <span className="secondary-color fs-5 fw-semibold">
            {CurrencyFormat(gridData[0]?.NetWorth || 0, 0)}
          </span>
        </div>
        <div className="bg-white flex-grow-1 p-3 rounded board-border board">
          <p className="mb-8">Profit For {moment(gridData[0]?.ReportDate).format('MMMM')}</p>
          <span className="secondary-color fs-5 fw-semibold">
            {CurrencyFormat(gridData[0]?.MTDPnL || 0, 2)}

          </span>
        </div>
        <div className="bg-white flex-grow-1 p-3 rounded board-border board">
          <p className="mb-8">Profit For Year to Date</p>
          <span className="secondary-color fs-5 fw-semibold">
            {CurrencyFormat(gridData[0]?.YTDPnL || 0, 2)}

          </span>
        </div>
      </div>
      </div>

      {/* <div className="d-flex flex-md-wrap mt-3 gap-3 col-md-6 col-6 " >
        <div className="bg-white flex-grow-1 p-3 rounded board-border board">
          <p className="mb-8">Net Worth - 11/30/2024</p>
          <span className="secondary-color fs-5 fw-semibold">
            {CurrencyFormat(gridData[0]?.NetWorth || 0, 2)}
          </span>
        </div>
        <div className="bg-white flex-grow-1 p-3 rounded board-border board">
          <p className="mb-8">Profit For {moment('11/30/2024').format('MMMM')}</p>
          <span className="secondary-color fs-5 fw-semibold">
            {CurrencyFormat(gridData[0]?.MTDPnL || 0, 2)}

          </span>
        </div>
        <div className="bg-white flex-grow-1 p-3 rounded board-border board">
          <p className="mb-8">Profit For Year to Date</p>
          <span className="secondary-color fs-5 fw-semibold">
            {CurrencyFormat(gridData[0]?.YTDPnL || 0, 2)}

          </span>
        </div>
      </div> */}
      </div>
     
        <div className="row mt-3">
          <div className="row">
          <TileLayout columns={2} rowHeight={255} positions={data} gap={{
              rows: 10,
              columns: 10
            }} 
             items={netWorthTitles} 
            onReposition={(e)=>{handleReposition(e,'NetWorth')}} />
          </div>
        </div>
  </>
  )
};
export default Composite;